/* Pure UI helpers for Survey Creation (Figma CrewKnit spec).
   Display math only — no API calls, no hooks, no JSX. */

import type { BadgeProps } from "../components/common/Badge";

export type SurveyLifecycleStatus = "published" | "draft" | "completed";

/** Status pill variant (Figma dc.html:7570). */
export function surveyStatusVariant(status: string): BadgeProps["variant"] {
  const s = (status || "").toLowerCase();
  if (s === "published") return "green";
  if (s === "completed") return "blue";
  return "gray";
}

/** "Closes 15 Jul 2026" vs "Closed 30 Jun 2026" from an end date. */
export function closeLabel(endDate: string | undefined, formatted: string): string {
  if (!endDate) return "Not scheduled";
  return new Date(endDate).getTime() >= Date.now() ? `Closes ${formatted}` : `Closed ${formatted}`;
}

/** "12 questions" label. */
export function questionCountLabel(n: number): string {
  return `${n} ${n === 1 ? "question" : "questions"}`;
}

/** "Used in 6 surveys" / "Not used yet" (usageCount is 0 when untracked). */
export function templateUsageLabel(n: number): string {
  if (!n || n <= 0) return "Not used yet";
  return `Used in ${n} ${n === 1 ? "survey" : "surveys"}`;
}
